export enum Orientation {
  horizontal = 'horizontal',
  vertical = 'vertical'
}
